// The colours of the design-system announcement banner (.home-announce and its modifier classes).
const AnnouncementBannerToneEnum = {
  Warning: '',
  Critical: 'crit',
  Info: 'info',
};

export default AnnouncementBannerToneEnum;
